<template>
    <div class="box">
        <div class="d-gray p-a">
            <span>Oceny jakości dostaw</span>
            <button class="btn btn-xs white pull-right m-r-sm" @click="generatePDF" :disabled="isLoading || evals.length === 0">
                <i class="fa fa-file-pdf-o"/> Generuj PDF
            </button>
            <button class="btn btn-xs white pull-right m-r-sm" @click="generateQuarterlyReport" :disabled="isLoading">
                <i class="fa fa-bar-chart"/> Generuj raport kwartalny
            </button>
        </div>
        <div class="box-divider m-a-0"/>
        <table class="table" v-if="!isLoading && evals.length > 0">
            <thead class="primary-color">
                <tr>
                    <th>Dostawa</th>
                    <th>Kategoria</th>
                    <th class="text-center">J/D/C</th>
                    <th class="text-center">Suma</th>
                    <th>Komentarze</th>
                    <th>Data dostawy</th>
                    <th>Utworzył</th>
                    <th/>
                </tr>
            </thead>
            <tbody>
                <tr v-for="evaluation in evals" :key="evaluation._id">
                    <td><span class="link" @click="showDetails(evaluation.order)">{{ evaluation.order.documentNo }}</span></td>
                    <td>{{ evaluation.goodsCategory }}</td>
                    <td class="text-center">
                        <span class="label" :class="getRatingClass(evaluation.rating.quality)">{{ evaluation.rating.quality }}</span> /
                        <span class="label" :class="getRatingClass(evaluation.rating.delivery)">{{ evaluation.rating.delivery }}</span> /
                        <span class="label" :class="getRatingClass(evaluation.rating.price)">{{ evaluation.rating.price }}</span>
                    </td>
                    <td class="text-center">
                        <span class="label label-info">{{ evaluation.totalScore }}/15</span>
                    </td>
                    <td>
                        <span v-if="evaluation.comments" class="text-muted">{{ evaluation.comments }}</span>
                        <span v-else class="text-muted">—</span>
                    </td>
                    <td>{{ evaluation.deliveryDate | moment('YYYY-MM-DD') }}</td>
                    <td>{{ SystemUsersManager.getName(evaluation.createdBy) }}<br>{{ formatDate(evaluation.createdAt) }}</td>
                    <td><a @click.prevent="editEval(evaluation._id)"><i class="material-icons text-blue md-16" style="font-size: 16px;">edit</i></a></td>
                </tr>
            </tbody>
        </table>

        <div class="row">
            <div class=" col-sm-12 text-right text-center-xs">
                <paginate
                    v-model="page"
                    :page-count="pages"
                    :click-handler="changePage"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :container-class="'pagination pagination-sm m-r'"/>
            </div>
        </div>

        <div v-if="!isLoading && evals.length === 0" class="text-center text-muted p-4">
            Brak danych do wyświetlenia
        </div>
        <Spinner v-if="isLoading"/>
    </div>
</template>
<script>
import Api from '../../Api.js';
import Spinner from '../Spinner.vue';
import SystemUsersManager from '../../SystemUsersManager.js';
import moment from 'moment';
import { generateSupplierEvaluationCardPDF } from '../../pdf-doc-generators/SupplierEvaluationCardPDF.js';
import { generateSupplierQuarterlyReportPDF } from '../../pdf-doc-generators/SupplierQuarterlyReportPDF.js';
import AddSupplierEvalModal from '../Production/Iso/AddSupplierEvalModal.vue';
import GenericModal from '../GenericModal.vue';
import GenericNumberSelectorModal from '../GenericNumberSelectorModal.vue';

export default {
    name: 'CustomerSupplierEvaluationCard',

    props: {
        customer: Object
    },

    components: {
        Spinner
    },

    data: function () {
        return {
            isLoading: false,
            evals: [],
            page: 1,
            limit: 15,
            pages: 1,
            SystemUsersManager: SystemUsersManager
        }
    },

    created: function() {
        this.loadData();
    },

    computed: {
    },
    methods: {
        async loadData() {
            this.isLoading = true;

            try {
                await SystemUsersManager.ensureLoaded();
                const { items: evals, total } = await Api.iso.suppliers.evaluations.get({
                    supplierId: this.customer._id,
                    page: this.page,
                    limit: this.limit
                });
                this.pages = Math.ceil(total / this.limit);

                const ordersSet = new Set(evals.map(r => r.orderId));
                const orders = await Api.stock.searchStockOrder({
                    _id: Array.from(ordersSet)
                });

                this.evals = evals.map(r => {
                    return {
                        ...r,
                        order: orders.data.find(o => o._id == r.orderId)
                    };
                });
            } catch (error) {
                this.$h.commonApiError(error);
            }
            this.isLoading = false;
        },

        changePage(pageNum) {
            this.loadData();
        },

        getRatingClass(rating) {
            if (rating >= 4) return 'success';
            if (rating >= 3) return 'warning';
            return 'danger';
        },

        formatDate(date) {
            if (!date) return '—';
            return moment(date).format('YYYY-MM-DD HH:mm');
        },

        async generatePDF() {
            const currentYear = new Date().getFullYear();
            const selectedYear = await this.$modal2.show(GenericNumberSelectorModal, {
                title: "Wybierz rok",
                min: currentYear - 5,
                max: currentYear,
                value: currentYear
            });

            if (!selectedYear) return;

            this.isLoading = true;
            try {
                await SystemUsersManager.ensureLoaded();
                const { items: evals } = await Api.iso.suppliers.evaluations.get({
                    supplierId: this.customer._id,
                    from: new Date(selectedYear, 0, 1).toISOString(),
                    to: new Date(selectedYear, 11, 31, 23, 59, 59, 999).toISOString(),
                    limit: 1000
                });

                if (evals.length === 0) {
                    this.$h.notify('Brak danych dla wybranego roku', 'warning');
                    this.isLoading = false;
                    return;
                }

                const ordersSet = new Set(evals.map(r => r.orderId));
                const orders = await Api.stock.searchStockOrder({
                    _id: Array.from(ordersSet)
                });

                const evalsWithOrders = evals.map(r => ({
                    ...r,
                    order: orders.data.find(o => o._id == r.orderId)
                }));

                const { items: qualifications } = await Api.iso.suppliers.qualifications.get({
                    supplierId: this.customer._id,
                    year: selectedYear,
                    limit: 1000
                });

                generateSupplierEvaluationCardPDF(
                    this.customer,
                    evalsWithOrders,
                    qualifications || [],
                    (userId) => SystemUsersManager.getName(userId)
                ).catch(error => {
                    console.error('Błąd podczas generowania PDF:', error);
                    this.$h.notify('Wystąpił błąd podczas generowania PDF', 'error');
                });
            } catch (error) {
                this.$h.commonApiError(error);
            }
            this.isLoading = false;
        },

        async generateQuarterlyReport() {
            const currentYear = new Date().getFullYear();
            const currentQuarter = Math.floor(new Date().getMonth() / 3) + 1;

            const result = await this.$modal2.show(GenericNumberSelectorModal, {
                title: 'Wybierz rok i kwartał',
                fields: [
                    { key: 'year',    label: 'Rok',     min: currentYear - 5, max: currentYear, value: currentYear },
                    { key: 'quarter', label: 'Kwartał', min: 1,               max: 4,           value: currentQuarter }
                ]
            });

            if (!result) return;

            const { year, quarter } = result;
            const from = new Date(year, (quarter - 1) * 3, 1).toISOString();
            const to   = new Date(year, quarter * 3, 0, 23, 59, 59, 999).toISOString();

            this.isLoading = true;
            try {
                await SystemUsersManager.ensureLoaded();
                const { items: evals } = await Api.iso.suppliers.evaluations.get({
                    supplierId: this.customer._id,
                    from,
                    to,
                    limit: 1000
                });

                if (evals.length === 0) {
                    this.$h.notify(`Brak danych dla Q${quarter} ${year}`, 'warning');
                    this.isLoading = false;
                    return;
                }

                const ordersSet = new Set(evals.map(r => r.orderId));
                const orders = await Api.stock.searchStockOrder({
                    _id: Array.from(ordersSet)
                });

                const evalsWithOrders = evals.map(r => ({
                    ...r,
                    order: orders.data.find(o => o._id == r.orderId)
                }));

                const { items: qualifications } = await Api.iso.suppliers.qualifications.get({
                    supplierId: this.customer._id,
                    year,
                    quarter,
                    limit: 100
                });

                generateSupplierQuarterlyReportPDF(
                    this.customer,
                    evalsWithOrders,
                    year,
                    quarter,
                    qualifications || [],
                    (userId) => SystemUsersManager.getName(userId)
                ).catch(error => {
                    console.error('Błąd podczas generowania raportu kwartalnego:', error);
                    this.$h.notify('Wystąpił błąd podczas generowania PDF', 'error');
                });
            } catch (error) {
                this.$h.commonApiError(error);
            }
            this.isLoading = false;
        },

        editEval: async function(evalId) {
            const r = await this.$modal2.show(AddSupplierEvalModal, {
                evaluationId: evalId
            });

            if (r) {
                this.loadData();
            }
        },

        showDetails: async function(pos) {
            const r = await this.$modal2.show(() => import('../Stock/modals/StockOrderPosModal.vue'), {
                orderPos: pos
            }, { width: '1100px' });
        }
    }
}
</script>
